export enum CompanyEnum {
  InmobiliariaPlatino = "Inmobiliaria Platino",
  ResidencialMaya = "Inmobiliaria Platino Maya",
  Invalle = "Invalle",
}
